import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { inject, NgModule, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

import { authInterceptor, errorInterceptor } from '@qiasphere/interceptors';
import { ClientConfigService } from '@qiasphere/services/client-config.service';
import { MSALService } from '@qiasphere/services/msal.service';
import { hotJarInit } from '@qiasphere/utils/hotjar';

import { AppComponent } from './app.component';
import { environmentProviders } from './app.providers';

/** Root application module that bootstraps the AppComponent and configures top-level routing for regular and service-account paths. */
@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    RouterModule.forRoot(
      [
        {
          path: 'service',
          data: {
            breadcrumb: 'QIAsphere(Service)',
            serviceMode: true
          },
          children: [
            { path: 'unauthorized', redirectTo: 'error/unauthorized', pathMatch: 'full' },
            { path: 'forbidden', redirectTo: 'error/forbidden', pathMatch: 'full' },
            {
              path: '',
              loadChildren: () => import('../qiasphere.module').then(m => m.QiasphereModule)
            }
          ]
        },
        {
          path: '',
          loadChildren: () => import('../qiasphere.module').then(m => m.QiasphereModule),
          data: {
            breadcrumb: 'QIAsphere'
          }
        }
      ],
      {
        initialNavigation: 'enabledBlocking',
        useHash: false,
        onSameUrlNavigation: 'reload',
        enableTracing: false
      }
    )
  ],
  providers: [
    ClientConfigService,
    provideAppInitializer(() => {
      const initializerFn = hotJarInit(inject(ClientConfigService));
      return initializerFn();
    }),
    provideAppInitializer(() => inject(MSALService).initialize()),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    ...environmentProviders
  ]
})
export class AppModule {}
